import { useForm } from 'react-hook-form';

/**
 * @typedef {import('react-hook-form').UseFormProps & {
 *   onSubmit?: (data: *) => void | Promise<void>,
 *   onError?: (errors: *) => void
 * }} UseFormWithDelayedSubmissionProps
 */

/**
 * @param {UseFormWithDelayedSubmissionProps} props
 */
export const useFormWithDelayedSubmission = props => {
  const { onSubmit, onError, ...formProps } = props;

  const form = useForm(formProps);
  const { handleSubmit } = form;

  const verify = async () => {
    let isValid = false;
    await handleSubmit(
      () => {
        isValid = true;
      },
      () => {
        onError?.();
        isValid = false;
      }
    )();
    return isValid;
  };

  const handleFormSubmit = handleSubmit(onSubmit, onError);

  return {
    form,
    verify,
    handleSubmit: handleFormSubmit
  };
};
